import TicketNotification from './TicketNotification';
import { STATUS_ICONS, statusLabel } from '../../../common/utils/tickets';
export default class TicketStatusChangedNotification extends TicketNotification {
  status() {
    return this.attrs.notification.content()?.to;
  }
  icon() {
    return STATUS_ICONS[this.status()] || 'fas fa-ticket';
  }
  href() {
    const ticket = this.ticket();
    return ticket ? super.href() : '#';
  }
  content() {
    return this.trans('status_changed_text', {
      status: statusLabel(this.status())
    });
  }
}
flarum.reg.add('soup-97-support', 'forum/components/notifications/TicketStatusChangedNotification', TicketStatusChangedNotification);